import { misc } from 'helpers/styles/constants';
import { useGetIsSidebarCollapsed } from 'store/layout/selectors';

export const useLayoutData = (canBeToggled = false) => {
  const isSidebarCollapsed = useGetIsSidebarCollapsed();

  const expandedSidebarWidth = 285;
  const collapsedSidebarWidth = 90;
  const currentSidebarWidth = isSidebarCollapsed ? collapsedSidebarWidth : expandedSidebarWidth;
  const sidebarWidth = canBeToggled ? currentSidebarWidth : expandedSidebarWidth;

  return {
    isSidebarCollapsed,
    sidebarWidth,
    contentWidth: misc.dashboardWidth - sidebarWidth,
  };
};
